import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SingleSelect from "../../../components/commonComponents/Selectors/SingleSelect";
import { updateStateData } from "../../../Store/actions";

const MarketingFilters = ({ redux_param_name, reduxKeywordToSaveValue, enabledFor }) => {
  const userStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [activitySelection, setActivitySelection] = React.useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const activityOptions =
    typeof userStateData.activityOptions !== "undefined" && userStateData.activityOptions.length !== 0
      ? userStateData.activityOptions.sort()
      : [];

  // Activity Type adds a hard-coded first option; Activity uses campaign activities only.
  const dropdownOptions =
    typeof enabledFor !== "undefined" && enabledFor === "activity_type_dropdown"
      ? ["Retailer Promotion", ...activityOptions]
      : activityOptions;

  React.useEffect(() => {
    if (dropdownOptions.length === 0) {
      setDataLoaded(true);
      return;
    }

    // Prefer value seeded at page load; fall back to first option.
    const seededValue = userStateData[reduxKeywordToSaveValue]?.[redux_param_name];
    const initialValue =
      typeof seededValue === "string" && dropdownOptions.includes(seededValue)
        ? seededValue
        : dropdownOptions[0];

    setActivitySelection({ value: initialValue, label: initialValue });

    // Only write Redux when seed was missing so we do not thrash an already-correct value.
    if (seededValue !== initialValue) {
      dispatchAction(
        updateStateData({
          [reduxKeywordToSaveValue]: {
            ...userStateData[reduxKeywordToSaveValue],
            [redux_param_name]: initialValue,
          },
        })
      );
    }

    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {dataLoaded === true && (
        <SingleSelect
          enableFullWidth={true}
          label={"Activity Type"}
          selectionCheck={(option, value) => option.label === value.label}
          options={dropdownOptions.map((activityName) => {
            return { value: activityName, label: activityName };
          })}
          sortOptions={typeof enabledFor !== "undefined" && enabledFor === "activity_type_dropdown" ? false : true}
          defaultVal={activitySelection}
          onChangeCall={(selectedOption) => {
            let userChoices = selectedOption.value;
            setActivitySelection(selectedOption);
            dispatchAction(
              updateStateData({
                [reduxKeywordToSaveValue]: {
                  ...userStateData[reduxKeywordToSaveValue],
                  [redux_param_name]: userChoices,
                },
              })
            );
          }}
        />
      )}
    </>
  );
};

export default MarketingFilters;
